import * as Sentry from '@sentry/nuxt'
import { useRuntimeConfig } from '#imports'
import { useLighthouse } from '~/composables/common/use-lighthouse'

const { SENTRY_DSN_URL = '' } = useRuntimeConfig().public

const isProd = process.env.NODE_ENV === 'production'
const { isLighthouseBot } = useLighthouse()

if (isProd && !isLighthouseBot) {
  Sentry.init({
    dsn: SENTRY_DSN_URL as string,
    sendDefaultPii: true,
    integrations: [Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  })
}
